<div class="container">
  <mat-card style="margin-top: 50px">
    <mat-card-content style="margin-left: auto; margin-right: auto">
      <div class="row">
        <div class="col-md-10">
          <h1 class="mt-5">
            Report Exports
            <i *ngIf="loadingData" class="fas fa-spinner fa-pulse"></i>
          </h1>
        </div>
        <div class="col-md-2"></div>
      </div>
      <div class="row">
        <div class="col-md-2 mainLabel">Interactive</div>
        <div class="col-md-2 mainLabel">Report</div>
        <div class="col-md-3 mainLabel">Export</div>
        <div class="col-md-2 mainLabel">Status</div>
        <div class="col-md-3 mainLabel"></div>
      </div>
      <ng-container *ngFor="let interactive of userState.interactives">
        <ng-container *ngFor="let report of interactive.currentReports">
          <div class="row table-row">
            <div class="col-md-2">{{ interactive.interactName }}</div>
            <div class="col-md-2">{{ report.reportName }}</div>
            <div class="col-md-3">{{ report.name }}</div>
            <div class="col-md-2">
              <ng-container *ngIf="report.status === -1"> Queued </ng-container>
              <ng-container *ngIf="report.status === 1">
                Complete
              </ng-container>
              <ng-container *ngIf="report.status === 2"> Failed </ng-container>
              <ng-container *ngIf="report.status == 0">
                Building Report ({{ report.statusDescription }})
              </ng-container>
            </div>
            <div class="col-md-3">
              <div style="display: flex; width: 100%">
                <div style="flex-grow: 1" *ngIf="report.status === 1">
                  <a href="#" (click)="downloadReportExport(report)"
                    ><b> [Download] </b></a
                  >
                </div>
                <div
                  style="flex-grow: 1"
                  *ngIf="report.owner && report.status === 1"
                >
                  <a href="#" (click)="editReportExport(interactive, report)"
                    ><b> [Edit] </b></a
                  >
                </div>
                <div style="flex-grow: 1" *ngIf="report.owner">
                  <a href="#" (click)="deleteReportExport(report)"
                    ><b> [Delete] </b></a
                  >
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </mat-card-content>
  </mat-card>
</div>
